import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-question-step-popup',
  templateUrl: './add-question-step-popup.component.html',
  styleUrls: ['./add-question-step-popup.component.css']
})
export class AddQuestionStepPopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-eight/add-question-step-popup/add-question-step-popup.component.ts